
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  emits: ["click"]
})
export default class IziIcon extends BaseElement {
  public handeleEventClick() {
    this.$emit("click");
  }
}
